import mongoose from "mongoose";
import { zNote } from "./note-resource";
import { getArrayOfUserSnippetsProjection, getUserSnippetPipeline } from "../users";
import { ResourceSubPipeline } from "../../utils";

function getNoteSharedWithPipeline(userId: mongoose.Types.ObjectId): ResourceSubPipeline {
  const sharedWithDocsProjection = getArrayOfUserSnippetsProjection("sharedWithDocs");

  return {
    mainStages: [
      { $unwind: { path: "$sharedWith", preserveNullAndEmptyArrays: true } },
      {
        $lookup: {
          from: "users",
          localField: "sharedWith",
          foreignField: "_id",
          as: "sharedWithDocs",
        },
      },
      { $unwind: { path: "$sharedWithDocs", preserveNullAndEmptyArrays: true } },
      {
        $group: {
          _id: "$_id",
          userId: { $first: "$userId" },
          title: { $first: "$title" },
          plainText: { $first: "$plainText" },
          text: { $first: "$text" },
          userDoc: { $first: "$userDoc" },
          tags: { $first: "$tags" },
          sharedWithDocs: {
            $push: {
              $cond: [
                { $or: [{ $eq: ["$userDoc._id", userId] }, { $eq: ["$sharedWithDocs._id", userId] }] },
                "$sharedWithDocs",
                "$$REMOVE",
              ],
            },
          },
          createdAt: { $first: "$createdAt" },
          updatedAt: { $first: "$updatedAt" },
        },
      },
    ],
    projectStage: {
      sharedWithDocs: sharedWithDocsProjection,
    },
  };
}

export function getNotesPipeLine(userId: mongoose.Types.ObjectId) {
  const userSnippet = getUserSnippetPipeline("userId", "userDoc");
  const noteSharedWithPipeline = getNoteSharedWithPipeline(userId);

  return {
    _z: zNote,
    mainStages: [...userSnippet.mainStages, ...noteSharedWithPipeline.mainStages],
    projectStage: {
      _id: 1,
      title: 1,
      plainText: 1,
      text: 1,
      tags: 1,
      createdAt: 1,
      updatedAt: 1,
      ...noteSharedWithPipeline.projectStage,
      ...userSnippet.projectStage,
    },
  };
}
